import React, { createContext, useReducer,useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

const StaffContext = createContext();

const Setting={
  sidebar:true,
  office:false,
  research_notf:0,
  overload_notf:0,
  offering_notf:0,

}
const reducer = (state, action) => {
  switch (action.type) {
    case "collapse_expand":
      return {...state,sidebar:!state.sidebar};
    case "office_staff":
      return {...state,office:!state.office};
    case "localstorage":
      return action.payload;
    case "research":
      return {...state,research_notf:action.payload};
    case "overload":
      return {...state,overload_notf:action.payload};
    case "offering":
      return {...state,offering_notf:action.payload};
    default:
      return new Error();
  }
};



export function StaffContextProvider({ children }) {
  
  
  const [state, dispatch] = useReducer(reducer, Setting,(Setting) => JSON.parse(localStorage.getItem('MY_APP_STATE')) || Setting);
  const {changed}=useAuth();
  const api=useAxiosPrivate()
   useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`notification/viewNum/`,{
            signal:controller.signal
          })
          isMounted &&  response.data.forEach((res)=>{
            switch(res.type){
              case "/researches":
                dispatch({type:"research",payload:res.num})
                break;
              default:              
            }
          })}
        catch(err){
          console.error(err)
        }
      }
      getData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[changed])

useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const setData=async ()=>{
        try{
          isMounted &&   window.localStorage.setItem('MY_APP_STATE', JSON.stringify(state));
        }
        catch(err){
          console.error(err)
        }
      }
      setData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[state])

  return (
    <StaffContext.Provider value={{ state, dispatch }}>
      {children}
    </StaffContext.Provider>
  );
}

export default StaffContext;
